module.exports = __webpack_public_path__ + "./img/avatar-2.410b98f04c1181c67eed84798890e9bf.webp";